import { Component } from '@angular/core';
import {HttpClient } from '@angular/common/http'; 
import { AuthService } from '../../_services'; 

@Component({
  selector: 'Hrms',
  templateUrl: './target.component.html',  
})

 export class TargetComponent {
 public prjId:any
 public userId:any
  constructor(private http : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit() 
  { 
     
  }

}
 


// WEBPACK FOOTER //
// ./src/app/admin/target/target.component.ts